import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import PromoComplexPopup from 'apps/promo/components/popup/PromoComplexPopup';
import { generateReferralAppLink, resolveOneLinkUrl } from 'apps/promo/helpers/oneLinkSmartScript';

import { PromoButton } from '../promo-button/PromoButton';
import { PromoRow } from '../PromoRow/PromoRow';

const BtnContainer = styled.div`
    margin-top: 64px;
    text-align: right;
`;

const DownloadAppPopup = (props) => {
    const [btnHref, setBtnHref] = useState(props.btnHref);

    useEffect(() => {
        setBtnHref(props.btnHref);

        if (!props.inviteCode || !props.oneLinkUrl) return;

        let isActive = true;
        generateReferralAppLink({ oneLinkUrl: props.oneLinkUrl, inviteCode: props.inviteCode }).then((link) => {
            if (isActive && link) setBtnHref(link);
        });

        return () => {
            isActive = false;
        };
    }, [props.btnHref, props.oneLinkUrl, props.inviteCode]);

    return (
        <PromoComplexPopup withoutButton popupRef={props.popupRef}>
            {props.img && (
                <PromoRow indent={'adaptive-24-32'}>
                    <img src={props.img?.[0].url} alt={''} />
                </PromoRow>
            )}
            <PromoRow indent={'adaptive-24-32'}>
                <PromoText color="gray80" tag="div" variant="h3">
                    {props.popupTitle}
                </PromoText>
            </PromoRow>
            <PromoText color="gray40" tag="div" variant="subheader">
                {props.popupSubTitle}
            </PromoText>
            {props.btnCaption && (
                <BtnContainer>
                    <PromoButton caption={props.btnCaption} type={'link'} href={btnHref} id={'downloadAppBtn'} />
                </BtnContainer>
            )}
        </PromoComplexPopup>
    );
};

DownloadAppPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    popupTitle: PropTypes.string,
    popupSubTitle: PropTypes.string,
    btnCaption: PropTypes.string,
    btnHref: PropTypes.string,
    img: PropTypes.array,
    inviteCode: PropTypes.string,
    oneLinkUrl: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        popupTitle: state.extra?.strapiApi?.download_app_popup?.title,
        popupSubTitle: state.extra?.strapiApi?.download_app_popup?.subtitle,
        btnCaption: state.extra?.strapiApi?.download_app_popup?.btn_cta?.title,
        btnHref: state.extra?.strapiApi?.download_app_popup?.btn_cta?.url,
        img: state.extra?.strapiApi?.download_app_popup?.img,
        oneLinkUrl: resolveOneLinkUrl(state.extra?.strapiApi?.download_app_popup),
    };
};
export default connect(mapStateToProps, null)(DownloadAppPopup);
